import { Box } from '@mui/material';
import React from 'react';
import MuiDialogWrapper from '../../components/MuiDialogWrapper/MuiDialogWrapper';

interface CustomDialogProps {
    close: any;
    data: any;
}

const CustomDialog: React.FC<CustomDialogProps> = ({ close, data }) => {
    return (
        <MuiDialogWrapper
            styles={data.styles}
            title={data.title}
            onClose={close}
            content={<Box>{data.content}</Box>}
            buttons={data.buttons}
            prefixCloseWindow={data.actions ? data.actions : null}
        />
    );
};

export default CustomDialog;
